import { useMemo } from "react";
import { Modal } from "rsuite";
import { Button, SelectPicker } from "../../";

/**
 * Simple modal for ignoring transactions with reason selection
 */
export default function IgnoreTransactionModal({
  open,
  onClose,
  ignoreReasons,
  selectedIgnoreReason,
  onReasonChange,
  onConfirm,
  loading = false
}) {
   
    const ignoreReasonsData = useMemo(() => {
        if(!ignoreReasons || ignoreReasons.length === 0) {
            return [];
        }
        return ignoreReasons.filter((reason) => !reason?.systemOnly).map(reason => ({
            label: reason.reason,
            value: reason.id
        }));
    }, [ignoreReasons]);

  return (
    <Modal 
      open={open} 
      onClose={onClose} 
      backdrop="static" 
      keyboard={true} 
      overflow={false}
    >
      <Modal.Header>
        <h5>Ignore Transaction</h5>
      </Modal.Header>
      
      <Modal.Body style={{ height: 100 }}>
        <p>Please select a reason for ignoring this transaction:</p>
        <div style={{ marginTop: "15px" }}>
          <SelectPicker
            data={ignoreReasonsData}
            valueKey="value"
            labelKey="label"
            defaultValue={selectedIgnoreReason?.id}
            onChange={onReasonChange}
            testid="ignore-reason-select"
            placeholder="Select an ignore reason..."
            style={{ width: "100%" }}
          />
        </div>
      </Modal.Body>
      
      <Modal.Footer>
        <Button
          text="Confirm"
          appearance="primary"
          onClick={onConfirm}
          disabled={!selectedIgnoreReason || loading}
          data-testid="confirm-ignore-btn"
        />
        <Button
          text="Cancel"
          appearance="subtle"
          color="red"
          onClick={onClose}
          data-testid="cancel-ignore-btn"
        />
      </Modal.Footer>
    </Modal>
  );
}